import { Link } from 'react-router-dom';
import { CITY_DATA } from '@/mocks/productCityData';

const CITY_ENTRIES = Object.entries(CITY_DATA);

interface CitiesSectionProps {
  productName: string;
  productPath: string;
}

export default function CitiesSection({ productName, productPath }: CitiesSectionProps) {
  const productSlug = productPath.replace('/products/', '');

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1200px' }}>
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {productName} в&nbsp;Белебее, Ермекеево, Туймазах, Уфе и&nbsp;других городах
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Изготавливаем {productName.toLowerCase()} под ключ с&nbsp;выездом на&nbsp;замер и&nbsp;монтажом.
            Работаем во&nbsp;всех населённых пунктах юго-запада Башкортостана и&nbsp;соседних регионов —
            от&nbsp;Приютово до&nbsp;Уфы, от&nbsp;Бугуруслана до&nbsp;Бавлов.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {CITY_ENTRIES.map(([citySlug, city]) => (
            <Link
              key={citySlug}
              to={`/products/${productSlug}/${citySlug}`}
              className="flex items-center gap-2.5 bg-background-100 border border-background-200/50 rounded-md px-3.5 py-2.5 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0">
                <i className="ri-map-pin-line text-xs"></i>
              </span>
              <span className="text-sm font-medium text-foreground-800">{city.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}